import axManage from './axManage';

// 请求token
export function GetToken(data = {}) {
  return axManage({
    url: '/api/User/GetToken',
    method: 'post',
    data: data,
  });
}

// 登录时请求图片验证码
export function GetCode(data = {}) {
  return axManage({
    url: '/api/User/GetCode',
    method: 'post',
    data: data,
  });
}

// 管理后台登录
export function Login(data = {}) {
  return axManage({
    url: '/api/User/Login',
    method: 'post',
    data: data,
  });
}

// 管理后台选择产品
export function GetProduct_ComboBox(data = {}) {
  return axManage({
    url: '/api/Product/GetProduct_ComboBox',
    method: 'post',
    data: data,
  });
}

// 管理后台选择代理商
export function GetProductAgent_ComboBox(data = {}) {
  return axManage({
    url: '/api/User/GetProductAgent_ComboBox',
    method: 'post',
    data: data,
  });
}

// 管理后台选择商户
export function GetUserList_Combox(data = {}) {
  return axManage({
    url: '/api/User/GetUserList_Combox',
    method: 'post',
    data: data,
  });
}

// 小微商户审核列表
export function GetXWSHAuditList(data = {}) {
  return axManage({
    url: '/api/MerChant/GetXWSHAuditList',
    method: 'post',
    data: data,
  });
}

// 小微商户审核详情
export function GetXWSHAuditDetail(data = {}) {
  return axManage({
    url: '/api/MerChant/GetXWSHAuditDetail',
    method: 'post',
    data: data,
  });
}

// 审核小微商户
export function AuditXWSH(data = {}) {
  return axManage({
    url: '/api/MerChant/AuditXWSH',
    method: 'post',
    data: data,
  });
}

// 企业微信/管理员绑定企业微信
export function BindingWorkWXOpenid(data = {}) {
  return axManage({
    url: '/api/WorkWX/bindingWorkWXOpenid',
    method: 'post',
    data: data,
  });
}

// 企业微信/获取企业OPENID
export function GetWorkWXOpenid(data = {}) {
  return axManage({
    url: '/api/WorkWX/getWorkWXOpenid',
    method: 'post',
    data: data,
  });
}

// 企业微信/通过OPENID登录
export function LoginByWorkWXOpenid(data = {}) {
  return axManage({
    url: '/api/WorkWX/loginByWorkWXOpenid',
    method: 'post',
    data: data,
  });
}

// 企业微信-一周工作报表
export function GetWeeklyReport(data = {}) {
  return axManage({
    url: '/api/WorkWX/getWeeklyReport',
    method: 'post',
    data: data,
  });
}

// 设置二级代理商激活、达标、优质商户奖励详情
export function GetUserCXZFTaskDetail(data = {}) {
  return axManage({
    url: '/api/Agent/GetUserCXZFTaskDetail',
    method: 'post',
    data: data,
  });
}

// 查询活动奖励设置
export function ShowTaskRewardSetting(data = {}) {
  return axManage({
    url: '/app/Agent/ShowTaskRewardSetting',
    method: 'post',
    data: data,
  });
}

// 设置奖励金额
export function ChangeTaskRewardSetting(data = {}) {
  return axManage({
    url: '/app/Agent/ChangeTaskRewardSetting',
    method: 'post',
    data: data,
  });
}

// 设置二级代理商激活、达标、优质商户奖励
export function SetCXZFUserTask(data = {}) {
  return axManage({
    url: '/api/Agent/SetCXZFUserTask',
    method: 'post',
    data: data,
  });
}

// 设置代理商小微达标奖励
export function ChangeXWSHTaskRewardSetting(data = {}) {
  return axManage({
    url: '/app/Agent/ChangeXWSHTaskRewardSetting',
    method: 'post',
    data: data,
  });
}
